import React, { useContext } from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import Flex from '../../Flex';
import { TabsContext } from '../context';

export default function Tab({ label = '', value = null, disabled = false }) {
  const {
    activeValue = null,
    isDisabled = false,
    tabClassName = '',
    activeTabClassName = '',
    onChange = () => {},
  } = useContext(TabsContext);

  const isActive = activeValue === value;
  const isTabDisabled = isDisabled || disabled;

  const onTabClick = () => {
    if (isTabDisabled || isActive) return;
    onChange(value);
  };

  return (
    <Flex
      gap={8}
      align="center"
      justify="center"
      onClick={onTabClick}
      data-active={isActive}
      data-disabled={isTabDisabled}
      className={cn(
        styles.pill,
        { [activeTabClassName]: isActive },
        tabClassName,
      )}
    >
      {label}
    </Flex>
  );
}
